<template>
  <div
    v-if="ghost"
    class="absolute left-0.5 right-0.5 z-30 rounded pointer-events-none overflow-hidden"
    :class="ghost.mode === 'create'
      ? 'bg-blue-600/85 border border-blue-700'
      : 'bg-blue-600/70 border-2 border-blue-700 border-dashed'"
    :style="{ top: `${ghost.top}px`, height: `${ghost.height}px` }"
  >
    <div class="px-1.5 py-0.5 text-white text-[11px] leading-tight">
      <p class="font-medium truncate">{{ label }}</p>
      <p v-if="ghost.height >= 30" class="truncate opacity-90">{{ timeRange }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useCalendarGeometry } from 'composables/useCalendarGeometry.js'

// The preview chip shown while a create/move/resize gesture is live. Without a
// running time label a drag gives no feedback about what it will produce.

const props = defineProps({
  ghost: { type: Object, default: null },
})

const { is24Hour } = useCalendarGeometry()

const label = computed(() => {
  if (!props.ghost) return ''
  if (props.ghost.mode === 'create') return '(No title)'
  return props.ghost.booking?.title || props.ghost.booking?.name || '(No title)'
})

function minutesLabel(minutes) {
  const h = Math.floor(minutes / 60) % 24
  const m = minutes % 60
  if (is24Hour.value) return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  const suffix = h >= 12 ? 'PM' : 'AM'
  const hour12 = h % 12 === 0 ? 12 : h % 12
  return m === 0 ? `${hour12} ${suffix}` : `${hour12}:${String(m).padStart(2, '0')} ${suffix}`
}

const timeRange = computed(() => {
  if (!props.ghost) return ''
  return `${minutesLabel(props.ghost.startMinutes)} to ${minutesLabel(props.ghost.endMinutes)}`
})
</script>
